// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"ToggleStepDetailsButton_buttonWrapper__j2F8M","text":"ToggleStepDetailsButton_text__FGDy8"};